import { supabase, SUPABASE_URL, SUPABASE_ANON_KEY } from './supabaseClient';

/* ══════════════════════════════════════════════════════════════════════════
   trackEvent — az `events` tábla írása
   ─────────────────────────────────────────────────────────────────────────
   Korábban a TagActivationModal-ban élt inline; innen exportálva a watchdog és
   a többi hívó is eléri. A séma: docs/esemenykovetes.md a landing repóban.

   Oszlopnevek: event_name / properties / user_id. A korábbi name/props pár
   minden híváson PGRST204-gyel elszállt, és a hiba csak console.warn-ban
   látszott — ezért logolunk, nem nyelünk el csendben.
   ══════════════════════════════════════════════════════════════════════════ */

export async function trackEvent(name, props, user) {
  try {
    const { error } = await supabase.from('events').insert({
      event_name: name,
      properties: props || {},
      user_id: user?.id || null,
    });
    if (error) console.warn('[trackEvent]', name, error.message);
  } catch (e) {
    console.warn('[trackEvent]', name, e);
  }
}

/* ── Nyers változat, supabase-js nélkül ──
   A supabase.from() a háttérben _getAccessToken()-t hív, az pedig
   auth.getSession()-t — vagyis UGYANARRA AZ AUTH LOCKRA vár, ami a végtelen
   betöltést okozza. Ha a lock beragadt, a normál trackEvent is elakadna, és
   pont azt az esetet nem mérnénk, ami érdekel.

   Ez a változat közvetlenül a REST végpontot hívja az anon kulccsal. Csak
   diagnosztikai eseményekhez (loading_stuck, auth_init_failed).
   Minden hibát elnyel: a mérés soha ne okozzon új hibát. */
export function trackEventRaw(name, props) {
  try {
    fetch(`${SUPABASE_URL}/rest/v1/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        Prefer: 'return=minimal',
      },
      body: JSON.stringify({ event_name: name, properties: props || {}, user_id: null }),
      keepalive: true,
    }).catch(() => { /* némán */ });
  } catch (e) { /* némán */ }
}
